import React from "react";
import { formatMessage } from "../../../utils/helpers/LanguageHelper";
import { DocumentParametersCard } from "./DocumentParametersCard";
import useDocumentParameters, { DocumentParametersProps } from "./DocumentParametersHook";

export const DocumentParameters: React.FunctionComponent<DocumentParametersProps> = (props) => {
  const { state, parameters, updateParameters, inheritableParameters, updateDimensionFromTree, readonly } =
    useDocumentParameters(props);

  return (
    <div className="ms-Grid-row">
      <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
        {state.availableDbApplication?.length ? (
          state.availableDbApplication.map((dbApplication) => {
            const dbParameters = parameters.find((p) => p.dbId === dbApplication.id);
            const inheritableDbParameters = inheritableParameters?.find((p) => p.dbId === dbApplication.id);
            return (
              <DocumentParametersCard
                key={dbApplication.id}
                inheritableDbParameters={inheritableDbParameters}
                updateDimensionFromTree={(dimensionItem, newDimensions) =>
                  updateDimensionFromTree(dimensionItem, newDimensions, dbParameters)
                }
                dimensions={dbParameters?.dimensions}
                selectedDbApplication={dbApplication}
                enableDbApplication={(enabled) => {
                  if (readonly) return;
                  const newDocParams = parameters.filter((p) => p.dbId !== dbApplication.id) ?? [];
                  if (enabled) {
                    newDocParams.push({
                      dbId: inheritableDbParameters?.dbId ?? dbApplication.id,
                      dimensions:
                        inheritableDbParameters?.dimensions.map((d) => ({
                          ...d,
                          inherited: true,
                        })) ?? [],
                    });
                  }

                  updateParameters(newDocParams, true, true);
                }}
                canInherit={props.canInherit}
                readonly={readonly}
              />
            );
          })
        ) : (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <img
              src={"/assets/genericErrorIllustration.svg"}
              alt="No database associated with the current user"
              style={{
                width: "calc(100vw - 4rem)",
                maxHeight: "calc(100vh - 3rem)",
                objectFit: "contain",
              }}
            />
            <span
              style={{
                width: "100%",
                textAlign: "center",
                color: "var(--color-blue)",
                lineBreak: "anywhere",
              }}
            >
              {formatMessage("cof.documentproperties.parameters.error.nodatabase")}
            </span>
          </div>
        )}
      </div>
    </div>
  );
};
